import { Container, ingenuity, killDelayedCall, Linear } from "@quest/base-core";
import { GameIntroView, SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist"
export class GameIntroViewGame extends GameIntroView {
  private tweenCollectionArray: any[] = []
  // overrided to kill all tweeens in the view
  protected resetValues(): void {
    killDelayedCall("delayToNextSlide");
    this.removeTweenFromScreen();
    this.tweenCollectionArray = [];
    this.gameIntroLogo?.scale.set(1);
    this.gameIntroLogo?.pivot.set(0);
    this.gameIntroCharacterContainer?.scale.set(1);
    this.gameIntroCharacterContainer?.pivot.set(0);
    this.gameIntroCharacterContainer?.position.set(0);
    this.elementMainContainer?.scale.set(1);
    this.elementMainContainer?.pivot.set(0);
    this.elementMainContainer?.position.set(0);
    this.gameFeatureLabelContainer1 && (this.gameFeatureLabelContainer1.alpha = 1);
    this.gameFeatureLabelContainer2 && (this.gameFeatureLabelContainer2.alpha = 1);
  }
  protected async showPortraitSlides(): Promise<void> {
    this.tweenCollectionArray = [];
    super.showPortraitSlides();
  }
  private removeTweenFromScreen(): void {
    this.tweenCollectionArray?.forEach((tween: any) => {
      ingenuity.currentGame.tweens.remove(tween);
    })
  }
  /**
   * to add tweens in array to remove them
   */
  protected fadeOutTween(container: Container): any {
    return new Promise((resolve) => {
      const tween = ingenuity.currentGame.add.tween(container);
      this.tweenCollectionArray.push(tween)
      tween.to({ alpha: 0 }, 600, Linear.None, true);
      tween.onComplete.addOnce(resolve);
    });
  }
  /**
   * to add tweens in array to remove them
 */
  protected fadeInTween(container: Container): any {
    return new Promise((resolve) => {
      container.alpha = 0;
      const tween = ingenuity.currentGame.add.tween(container);
      this.tweenCollectionArray.push(tween)
      tween.to({ alpha: 1 }, 600, Linear.None, true);
      tween.onComplete.addOnce(resolve);
    });
  }




      // Add to set game intro container values
      allignPortraitCharacter() {
          // const scale = Math.min((innerHeight / this.getImageById("gameIntroPortrait").height), (innerWidth / this.getImageById("gameIntroPortrait").width));
          // this.gameIntroCharacterContainer && this.gameIntroCharacterContainer.scale.set(scale);
          // this.gameIntroCharacterContainer && this.gameIntroCharacterContainer.pivot.set(ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER, 0);
          // this.gameIntroCharacterContainer && (this.gameIntroCharacterContainer.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER);
          // this.gameIntroCharacterContainer && (this.gameIntroCharacterContainer.y = 0);
      }
      // to allign portrait slides
     protected allignPortraitSlides(scaleValue?:any) {
          const scale = Math.min((innerHeight / this.getImageById("gameIntroPortrait").height), (innerWidth / this.getImageById("gameIntroPortrait").width));
          this.elementMainContainer && this.elementMainContainer.scale.set(scale);
          this.elementMainContainer && this.elementMainContainer.pivot.set(ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER);
          this.elementMainContainer && (this.elementMainContainer.x = innerWidth * SlotConstantsBehavior.HALF_CONVERTER);
          this.elementMainContainer && (this.elementMainContainer.y = innerHeight* SlotConstantsBehavior.HALF_CONVERTER);
      }
}
